/**
 * Pagination configuration for the application
 */

/**
 * Number of draws to fetch per page
 * Change to 20 or higher for production
 */
export const PAGE_SIZE = 10;
/**
 * Maximum number of draws the backend allows per request
 */
export const MAX_PAGE_SIZE = 100;
